export const CAROUSEL_SMALL_SQUARE = 'square-small';
export const CAROUSEL_SMALL_LANDSCAPE = 'landscape-small';
